import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material'
import { Box, Breadcrumbs, Typography } from '@mui/material'
import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { CustomButton } from '@/shared/ui/button'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { CustomTab } from '@/shared/ui/tab'
import { CustomTabs } from '@/shared/ui/tabs'

export const Route = createFileRoute('/_auth/canteen/meal-restrictions/restriction/$restrictionId')(
  {
    component: RouteComponent,
  }
)

function RouteComponent() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { restrictionId } = useParams({
    from: '/_auth/canteen/meal-restrictions/restriction/$restrictionId',
  })

  const handleBack = () => {
    navigate({ to: '/canteen/meal-restrictions' })
  }

  const getActiveTab = () => {
    if (location.pathname.includes('/allergens')) {
      return 'allergens'
    }
    return 'common'
  }

  return (
    <PageWrapper title={t('Карточка ограничения')}>
      <Box display="flex" gap={2} alignItems="center">
        <CustomButton
          size="small"
          variant="outlined"
          color="secondary"
          startIcon={<ArrowBackIos />}
          onClick={handleBack}
        >
          {t('Назад')}
        </CustomButton>
        <Breadcrumbs separator={<ArrowForwardIos sx={{ fontSize: 16 }} />}>
          <Typography color="text.secondary" key="1">
            {t('Список ограничений в питании учеников')}
          </Typography>
          <Typography key="2" color="text.primary">
            {t('Карточка ограничения')}
          </Typography>
        </Breadcrumbs>
      </Box>
      <CustomTabs value={getActiveTab()} variant="scrollable" scrollButtons="auto">
        <CustomTab
          onClick={() =>
            navigate({
              to: '/canteen/meal-restrictions/restriction/$restrictionId/common',
              params: { restrictionId },
            })
          }
          value="common"
          label={t('Основное')}
        />
        <CustomTab
          onClick={() =>
            navigate({
              to: '/canteen/meal-restrictions/restriction/$restrictionId/allergens',
              params: { restrictionId },
            })
          }
          value="allergens"
          label={t('Список аллергенов в утвержденных меню')}
        />
      </CustomTabs>
      {/* Extra bottom padding to prevent content from being hidden behind fixed footer */}
      <Box sx={{ pb: 19 }}>
        <Outlet />
      </Box>
    </PageWrapper>
  )
}
